module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination-large.a078578e.png";